const initState = {
  trucks: [],
  searched: [],
  truck: {},
  truckToast: null,
  isLoading: false,
  isLoaded: false,
};

export const truckReducer = (state = initState, action) => {
  switch (action.type) {
  case 'RESET_TRUCK_STATE':
    return {
      ...initState
    };
  case 'RESET_TOAST_STATE':
    return {
      ...state,
      truckToast: null,
      isLoading: false,
    };
  case 'PROCESSING_TRUCK':
    return {
      ...state,
      truckToast: { type: 'LOADING', message: 'Please wait ...' },
      isLoading: true,
    };

  case 'FETCH_TRUCKS':
    return {
      ...state,
      trucks: action.payload,
      truckToast: { type: 'SUCCESS' },
      isLoading: false,
      isLoaded: true, // This is to make sure we avoid additional fetch calls.
    };
  case 'ADD_TRUCK':
    return {
      ...state,
      trucks: [...state.trucks, action.payload],
      truckToast: { type: 'SUCCESS', message: 'Truck saved successfully.' },
      isLoading: false,
    };
  case 'UPDATE_TRUCK':
    return {
      ...state,
      trucks: state.trucks.map(truck => truck.id === action.payload.id ? { ...action.payload } : { ...truck }),
      searched: state.searched.map(truck => truck.id === action.payload.id ? { ...action.payload } : { ...truck }),
      truckToast: { type: 'SUCCESS', message: 'Truck updated successfully.' },
      isLoading: false,
    };
  case 'SEARCH_TRUCKS':
    return {
      ...state,
      searched: action.payload,
      truckToast: { type: 'SUCCESS' },
      isLoading: false,
    };
  case 'TRUCK_ERROR':
    return {
      ...state,
      isLoading: false,
      truckToast: { type: 'ERROR', message: action.payload },
    };
  default:
    return state;
  }
};
